export var ContainerTypeEnum;
(function (ContainerTypeEnum) {
    ContainerTypeEnum[ContainerTypeEnum["CHARACTER"] = 1581111423] = "CHARACTER";
    ContainerTypeEnum[ContainerTypeEnum["ITEM"] = 1439493548] = "ITEM";
    ContainerTypeEnum[ContainerTypeEnum["CAMPAIGN"] = 618115330] = "CAMPAIGN";
    ContainerTypeEnum[ContainerTypeEnum["SHOPPE"] = -1] = "SHOPPE";
})(ContainerTypeEnum || (ContainerTypeEnum = {}));
